import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const Placeholder = ({ icon, content }) => (
  <div className="container-fluid text-center placeholder-container">
    <div className="row">
      <div className="col-xs-12">
        <i className={`ico ico-lg ${icon} text-gray`}></i>
      </div>
      <div className="col-xs-12">
        <h5>
          <FormattedMessage
            id="boards.placeholder.no_content"
            defaultMessage="You have no {content}."
            values={{
              content: content
            }}
          />
        </h5>
      </div>
    </div>
  </div>
);

export const PlaceholderWithBtn = ({ icon, text, link, buttonText = null }) => {
  return (
    <div className="row" style={{ marginTop: '50px' }}>
      <div className="col-xs-12 text-center">
        <i className={`${icon} text-gray-400`} style={{ fontSize: '30px' }} />
        <h5>{text}</h5>
        <div style={{ marginTop: '30px' }}>
          <a href={link} className="btn btn-primary">{ buttonText ||
          <FormattedMessage
            id="boards.placeholder_with_btn.explore"
            defaultMessage="Explore Spaces"
          />
          }
          </a>
        </div>
      </div>
    </div>
  );
};

Placeholder.propTypes = {
  icon: PropTypes.string,
  content: PropTypes.string
};

PlaceholderWithBtn.propTypes = {
  icon: PropTypes.string,
  content: PropTypes.string,
  link: PropTypes.string
};
